// Shared date-range presets for report/analytics dashboards.
export const DATE_PRESETS = [
  { key: 'month', label: 'This Month' },
  { key: 'quarter', label: 'Last 3 Months' },
  { key: 'ytd', label: 'Year to Date' },
  { key: 'year', label: 'Last 12 Months' },
  { key: 'all', label: 'All Time' },
];

export function getDateRangeForPreset(preset) {
  const now = new Date();
  if (preset === 'month') return { from: new Date(now.getFullYear(), now.getMonth(), 1), to: now };
  if (preset === 'quarter') return { from: new Date(now.getFullYear(), now.getMonth() - 2, 1), to: now };
  if (preset === 'ytd') return { from: new Date(now.getFullYear(), 0, 1), to: now };
  if (preset === 'year') return { from: new Date(now.getFullYear() - 1, now.getMonth(), now.getDate()), to: now };
  return { from: null, to: null };
}
